import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/index.vue'
Vue.use(Router)

let routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const createRouter = () => new Router({
  mode: 'hash',
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})

const myRouter = createRouter()

// 路由切换动画
myRouter.beforeEach((to, from, next) => {
  next()
})

export default myRouter
